import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { guestGuard } from './guards/guest.guard';
import { roleGuard } from './guards/role.guard';
import { moduleGuard } from './guards/module.guard';

export const routes: Routes = [
    {
        path: 'admin/accept-invite',
        loadComponent: () => import('./pages/accept-invite/accept-invite.component').then((ai) => ai.AcceptInviteComponent)
    },
    {
        path: 'signup-options',
        loadComponent: () => import('./pages/signup-options/signup-options.component').then((so) => so.SignupOptionsComponent)
    },
    {
        path: 'sign-up',
        loadComponent: () => import('./pages/sign-up/sign-up.component').then((sp) => sp.SignUpComponent)
    },
    {
        path: 'verify-email',
        loadComponent: () => import('./pages/verify-email/verify-email.component').then((ve) => ve.VerifyEmailComponent)
    },
    {
        path: 'verify-email-success',
        loadComponent: () =>
            import('./pages/verify-email-success/verify-email-success.component').then((ves) => ves.VerifyEmailSuccessComponent)
    },
    {
        path: 'login',
        loadComponent: () => import('./pages/login/login.component').then((l) => l.LoginComponent),
        canActivate: [guestGuard]
    },
    {
        path: 'edit-profile',
        loadComponent: () => import('./pages/edit-profile/edit-profile.component').then((ep) => ep.EditProfileComponent),
        canActivate: [authGuard, roleGuard],
        data: { roles: ['creator', 'admin'] }
    },
    {
        path: 'view-profile/:id',
        loadComponent: () => import('./pages/view-profile/view-profile.component').then((vp) => vp.ViewProfileComponent)
    },
    {
        path: 'view-profile',
        loadComponent: () => import('./pages/view-profile/view-profile.component').then((vp) => vp.ViewProfileComponent)
    },
    {
        path: 'job-search',
        loadComponent: () => import('./pages/job-search-list/job-search-list.component').then((jsl) => jsl.JobSearchListComponent),
        canActivate: [authGuard]
    },
    {
        path: 'forgot-password',
        loadComponent: () => import('./pages/forgot-password/forgot-password.component').then((fp) => fp.ForgotPasswordComponent)
    },
    {
        path: 'set-new-password',
        loadComponent: () => import('./pages/set-new-password/set-new-password.component').then((snp) => snp.SetNewPasswordComponent)
    },
    {
        path: 'payment-detailes',
        loadComponent: () =>
            import('./pages/add-payment-details/add-payment-details.component').then((apd) => apd.AddPaymentDetailsComponent)
    },
    {
        path: 'payment-success',
        loadComponent: () =>
            import('./pages/payment-method-successful/payment-method-successful.component').then(
                (pms) => pms.PaymentMethodSuccessfulComponent
            )
    },
    {
        path: 'reset-verify-email',
        loadComponent: () => import('./pages/reset-verify-email/reset-verify-email.component').then((rve) => rve.ResetVerifyEmailComponent)
    },
    {
        path: 'password-reset-successfully',
        loadComponent: () =>
            import('./pages/password-reset-successfully/password-reset-successfully.component').then(
                (prs) => prs.PasswordResetSuccessfullyComponent
            )
    },
    {
        path: 'client-edit-profile',
        loadComponent: () =>
            import('./pages/client-edit-profile/client-edit-profile.component').then((cep) => cep.ClientEditProfileComponent),
        canActivate: [authGuard, roleGuard],
        data: { roles: ['client'] }
    },
    {
        path: 'create-job-post',
        loadComponent: () => import('./pages/create-job-post/create-job-post.component').then((cjp) => cjp.CreateJobPostComponent),
        canActivate: [authGuard, roleGuard],
        data: { roles: ['client'] }
    },
    {
        path: 'create-job-post/:id',
        loadComponent: () => import('./pages/create-job-post/create-job-post.component').then((cjp) => cjp.CreateJobPostComponent),
        canActivate: [authGuard, roleGuard],
        data: { roles: ['client'] }
    },
    {
        path: 'add-payment-details',
        loadComponent: () =>
            import('./pages/add-payment-details/add-payment-details.component').then((apd) => apd.AddPaymentDetailsComponent),
        canActivate: [authGuard]
    },
    {
        path: 'creator-add-payment-details',
        loadComponent: () =>
            import('./pages/creator-add-payment/creator-add-payment.component').then((capd) => capd.CreatorAddPaymentComponent),
        canActivate: [authGuard]
    },
    {
        path: 'job-details/:id',
        loadComponent: () => import('./pages/job-details/job-details.component').then((jd) => jd.JobDetailsComponent)
    },
    {
        path: 'client-view-profile/:id',
        loadComponent: () =>
            import('./pages/client-view-profile/client-view-profile.component').then((cvp) => cvp.ClientViewProfileComponent),
        canActivate: [authGuard, roleGuard],
        data: { roles: ['admin'] }
    },
    {
        path: 'client-view-profile',
        loadComponent: () =>
            import('./pages/client-view-profile/client-view-profile.component').then((cvp) => cvp.ClientViewProfileComponent),
        canActivate: [authGuard, roleGuard],
        data: { roles: ['client'] }
    },
    {
        path: 'creator-list',
        loadComponent: () => import('./pages/creator-list/creator-list.component').then((cl) => cl.CreatorListComponent)
    },
    {
        path: 'creator-empty-profile',
        loadComponent: () =>
            import('./pages/creator-empty-profile/creator-empty-profile.component').then((cep) => cep.CreatorEmptyProfileComponent),
        canActivate: [authGuard]
    },
    {
        path: 'client-dashboard',
        loadComponent: () => import('./pages/client-dashboard/client-dashboard.component').then((cd) => cd.ClientDashboardComponent),
        canActivate: [authGuard, roleGuard],
        data: { roles: ['client', 'creator'] }
    },
    {
        path: 'my-project',
        loadComponent: () => import('./pages/client-my-project/client-my-project.component').then((cmp) => cmp.ClientMyProjectComponent),
        canActivate: [authGuard]
    },
    {
        path: 'creator-my-project',
        loadComponent: () => import('./pages/creator-my-project/creator-my-project.component').then((mp) => mp.CreatorMyProjectComponent),
        canActivate: [authGuard]
    },
    {
        path: 'privacy-policy',
        loadComponent: () => import('./pages/privacy-policy/privacy-policy.component').then((pp) => pp.PrivacyPolicyComponent)
    },
    {
        path: 'terms-of-services',
        loadComponent: () => import('./pages/terms-of-service/terms-of-service.component').then((tos) => tos.TermsOfServiceComponent)
    },
    {
        path: 'submit-proposal/:id',
        loadComponent: () => import('./pages/submit-proposal/submit-proposal.component').then((sp) => sp.SubmitProposalComponent),
        canActivate: [authGuard, roleGuard],
        data: { roles: ['creator'] }
    },
    {
        path: 'proposal-list/:id',
        loadComponent: () => import('./pages/proposal-list/proposal-list.component').then((pl) => pl.ProposalListComponent),
        canActivate: [authGuard, roleGuard],
        data: { roles: ['client'] }
    },
    {
        path: 'proposal-details/:id',
        loadComponent: () => import('./pages/proposal-details/proposal-details.component').then((pd) => pd.ProposalDetailsComponent),
        canActivate: [authGuard]
    },
    {
        path: 'notifications',
        loadComponent: () => import('./pages/notification/notification.component').then((not) => not.NotificationComponent),
        canActivate: [authGuard]
    },
    {
        path: 'plan',
        loadComponent: () => import('./pages/plans/plans.component').then((ve) => ve.PlansComponent)
    },
    {
        path: 'add-payment/:id',
        loadComponent: () => import('./pages/add-payment-details/add-payment-details.component').then((ve) => ve.AddPaymentDetailsComponent)
    },
    {
        path: 'verify-payment',
        loadComponent: () => import('./pages/payment-confirmed/payment-confirmed.component').then((ve) => ve.PaymentConfirmedComponent)
    },
    {
        path: 'mfa-setup',
        loadComponent: () => import('./pages/mfa/mfa-setup.component').then((m) => m.MfaSetupComponent),
        canActivate: [authGuard, roleGuard],
        data: { roles: ['admin'] }
    },
    {
        path: 'mfa-verify',
        loadComponent: () => import('./pages/mfa/mfa-verify.component').then((m) => m.MfaVerifyComponent)
    },
    {
        path: 'admin-dashboard',
        loadComponent: () => import('./pages/admin-dashboard/admin-dashboard.component').then((ad) => ad.AdminDashboardComponent),
        canActivate: [authGuard, roleGuard, moduleGuard],
        data: { roles: ['admin'], moduleSlug: 'dashboard' }
    },
    {
        path: 'job-post-management',
        loadComponent: () =>
            import('./pages/job-post-management/job-post-management.component').then((jpm) => jpm.JobPostManagementComponent),
        canActivate: [authGuard, roleGuard, moduleGuard],
        data: { roles: ['admin'], moduleSlug: 'project-management' }
    },
    {
        path: 'policy-management',
        loadComponent: () =>
            import('./pages/policy-management/policy-management.component').then((pm) => pm.PolicyManagementComponent),
        canActivate: [authGuard, roleGuard, moduleGuard],
        data: { roles: ['admin'], moduleSlug: 'policies' }
    },
    {
        path: 'user-management',
        loadComponent: () => import('./pages/user-management/user-management.component').then((um) => um.UserManagementComponent),
        canActivate: [authGuard, roleGuard, moduleGuard],
        data: { roles: ['admin'], moduleSlug: 'user-management' }
    },
    {
        path: 'history-management',
        loadComponent: () =>
            import('./pages/history-management/history-management.component').then((hm) => hm.HistoryManagementComponent),
        canActivate: [authGuard, roleGuard, moduleGuard],
        data: { roles: ['admin'], moduleSlug: 'activity-logs' }
    },
    {
        path: 'api-logs',
        loadComponent: () =>
            import('./pages/api-logs/api-logs.component').then((page) => page.ApiLogsComponent),
        canActivate: [authGuard, roleGuard, moduleGuard],
        data: { roles: ['admin'], moduleSlug: 'api-logs' }
    },
    {
        path: 'coupon-management',
        loadComponent: () =>
            import('./pages/coupon-management/coupon-management.component').then((cm) => cm.CouponManagementComponent),
        canActivate: [authGuard, roleGuard, moduleGuard],
        data: { roles: ['admin'], moduleSlug: 'coupon-management' }
    },
    {
        path: 'user-details/:id/:userType',
        loadComponent: () => import('./pages/user-details/user-details.component').then((jd) => jd.UserDetailsComponent),
        canActivate: [authGuard, roleGuard, moduleGuard],
        data: { roles: ['admin'], moduleSlug: 'user-management' }
    },
    {
        path: 'edit-user/:id/:userType',
        loadComponent: () => import('./pages/edit-user/edit-user.component').then((jd) => jd.EditUserComponent),
        canActivate: [authGuard, roleGuard, moduleGuard],
        data: { roles: ['admin'], moduleSlug: 'user-management' }
    },
    {
        path: 'setting',
        loadComponent: () => import('./pages/setting/setting.component').then((sc) => sc.SettingComponent)
    },
    {
        path: 'chat',
        loadComponent: () => import('./pages/chat-screen/chat-screen.component').then((cs) => cs.ChatScreenComponent)
    },
    {
        path: 'support',
        loadComponent: () => import('./pages/email-support/email-support.component').then((um) => um.EmailSupportComponent),
        canActivate: [authGuard, roleGuard, moduleGuard],
        data: { roles: ['admin'], moduleSlug: 'support-queries' }
    },
    {
        path: 'query-details/:id',
        loadComponent: () =>
            import('./pages/email-support-details/email-support-details.component').then((um) => um.EmailSupportDetailsComponent),
        canActivate: [authGuard, roleGuard, moduleGuard],
        data: { roles: ['admin'], moduleSlug: 'support-queries' }
    },
    {
        path: 'case-management',
        loadComponent: () => import('./pages/case-management/case-management.component').then((cm) => cm.CaseManagementComponent),
        canActivate: [authGuard, roleGuard, moduleGuard],
        data: { roles: ['admin'], moduleSlug: 'contract-management' }
    },
    {
        path: 'case-details/:id',
        loadComponent: () => import('./pages/case-details/case-details.component').then((cd) => cd.CaseDetailsComponent),
        canActivate: [authGuard, roleGuard, moduleGuard],
        data: { roles: ['admin'], moduleSlug: 'contract-management' }
    },
    {
        path: 'review-management',
        loadComponent: () => import('./pages/review-management/review-management.component').then((rm) => rm.ReviewManagementComponent),
        canActivate: [authGuard, roleGuard, moduleGuard],
        data: { roles: ['admin'], moduleSlug: 'reviews' }
    },
    {
        path: 'role-management',
        loadComponent: () =>
            import('./pages/role-management/role-management.component').then((rm) => rm.RoleManagementComponent),
        canActivate: [authGuard, roleGuard, moduleGuard],
        data: { roles: ['admin'], moduleSlug: 'roles-permissions' }
    },
    {
        path: 'admin-user-management',
        loadComponent: () =>
            import('./pages/admin-user-management/admin-user-management.component').then((aum) => aum.AdminUserManagementComponent),
        canActivate: [authGuard, roleGuard, moduleGuard],
        data: { roles: ['admin'], moduleSlug: 'admin-users' }
    },
    {
        path: 'contact-us',
        loadComponent: () => import('./pages/contact-us/contact-us.component').then((um) => um.ContactUsComponent)
    },
    // {
    //     path: '',
    //     loadComponent: () => import('./pages/market-home/market-home.component').then((mh) => mh.MarketHomeComponent)
    // },
    {
        path: 'my-contact-reports',
        loadComponent: () => import('./pages/my-contact-reports/my-contact-reports.component').then((mcr) => mcr.MyContactReportsComponent),
        canActivate: [authGuard]
    },
    {
        path: '',
        loadComponent: () => import('./pages/login/login.component').then((l) => l.LoginComponent),
        canActivate: [guestGuard]
    },
    {
        path: 'market-home',
        loadComponent: () => import('./pages/market-home/market-home.component').then((mh) => mh.MarketHomeComponent)
    },
    {
        path: 'market-about',
        loadComponent: () => import('./pages/market-about/market-about.component').then((ma) => ma.MarketAboutComponent)
    },
    {
        path: 'market-contact-us',
        loadComponent: () => import('./pages/market-contact-us/market-contact-us.component').then((mcu) => mcu.MarketContactUsComponent)
    },
    {
        path: '404',
        loadComponent: () => import('./pages/not-found/not-found.component').then((nf) => nf.NotFoundComponent)
    },
    {
        path: '**',
        redirectTo: '404'
    }
];
